import { createSlice } from "@reduxjs/toolkit";


export const panierSlice = createSlice({
    name: 'panier',
    initialState:{},
    reducers: { //modify the selected spot in global state
        updateTaille: (currentState, action) => {
            let articleId=action.payload.id_article;
            const newPanier = currentState.map((item) =>
                item.id_article === articleId
                ? { ...item,
                    tailles:item.tailles.map((taille,index)=>
                        index===action.payload.index?
                        action.payload.value
                        : taille
                    )
                }
                : item
            )
            return newPanier 
        },

        updatePrenom: (currentState, action) => {
            let articleId=action.payload.id_article;
            const newPanier = currentState.map((item) =>
                item.id_article === articleId
                ? { ...item,
                    prenoms:item.prenoms.map((prenom,index)=>
                        index===action.payload.index?
                        action.payload.value
                        : prenom
                    )
                }
                : item
            )
            //console.log(newPanier);
            return newPanier 
        },

        newArticle: (currentState, action) => {
            
            let newPanier = currentState;

            newPanier.push({id_article:action.payload.id_article,qte:1,tailles:[0],prenoms:[""]})

            return newPanier
        },
        refillArticle: (currentState, action) => { // refill redux from db (edit contrat)
            
            let newPanier = currentState;

            newPanier.push({id_article:action.payload.id_article,qte:action.payload.qte,tailles:action.payload.tailles,prenoms:action.payload.prenoms})

            return newPanier
        },
        removeArticle: (currentState, action) => {
            
            let articleId=action.payload.id_article;
            let newPanier = currentState.filter((ligne)=>ligne.id_article!==articleId);
            return newPanier
        },

        incrementArticle: (currentState, action) => {
            
            let articleId=action.payload.id_article;
            const newPanier = currentState.map((item) =>
                item.id_article === articleId
                ? { ...item,
                    qte : item.qte+1,
                    tailles:item.tailles.concat([0]),
                    prenoms:item.prenoms.concat([""]),
                }
                : item
            )
            
            return newPanier 
        },

        decrementArticle: (currentState, action) => {
            
            let articleId=action.payload.id_article;
            const newPanier = currentState.map((item) =>
                item.id_article === articleId
                ? { ...item,
                    qte : item.qte-1,
                    tailles:item.tailles.slice(0,item.tailles.length-1),//remove last element of the array
                    prenoms:item.prenoms.slice(0,item.prenoms.length-1),//remove last element of the array
                 }
                : item
            )
            
            return newPanier 
        },
        resetPanier: (currentState, action) => {
            return [];
        }
       
    }
});